/*
 * Copyright (c) 2018-2019 Swiss Federal Railways
 *
 * This program and the accompanying materials are made
 * available under the terms of the Eclipse Public License 2.0
 * which is available at https://www.eclipse.org/legal/epl-2.0/
 *
 *  SPDX-License-Identifier: EPL-2.0
 */

/**
 * Entry point for all public APIs of this package.
 */
export * from './lib/platform-activator';
export * from './lib/platform';
export * from './lib/message-bus.service';
export * from './lib/router.service';
export * from './lib/uuid.util';
export * from './lib/view.service';
export * from './lib/activity.service';
export * from './lib/message-box.service';
export * from './lib/notification.service';
export * from './lib/intent.service';
export * from './lib/popup.service';
export * from './lib/manifest-registry.service';
export * from './lib/metadata';

export * from '@scion/workbench-application-platform.api';
